import React from "react";
import Container, {TooltipPhoto} from "./styles";
import IComponentPhoto from "./interface";

const Photo: React.FC<IComponentPhoto> = ({
	name, 
	hover,
	email,
	link, 
	width = 30, 
	height = 30,
	widthOnHover = 80,
	heightOnHover = 80, 
	styleInline
}) => {
	if(link != null && link !== "")
		return (
			<TooltipPhoto>
				<Container photo width={width} height={height} style={{backgroundImage: `url(${link})`}} styleInline={styleInline}></Container>
				{hover && (
					<span>
						<Container photo width={widthOnHover} height={heightOnHover} style={{backgroundImage: `url(${link})`}}></Container>	
						<div className="texts name">{name}</div>
						<div className="texts">{email}</div>
					</span>
				)}
			</TooltipPhoto>
		);
	const arrName = name.split(" ").filter((x) => x.trim().length > 0);
	return (
		<TooltipPhoto>
			<Container photo={false} width={width} height={height} styleInline={styleInline} >{name.charAt(0)}{arrName.length > 1 && arrName[arrName.length - 1].charAt(0)} </Container>
			{hover && (
				<span>
					<Container photo={false} width={widthOnHover} height={heightOnHover} style={{fontSize: "2rem"}}>{name.charAt(0)}{arrName.length > 1 && arrName[arrName.length - 1].charAt(0)} </Container>	
					<div className="texts name">{name}</div>
					<div className="texts">{email}</div>
				</span>
			)}
		</TooltipPhoto>
	);
};

export default Photo;
